{
  "INTEGRATION_APPS": {
    "FETCHING": "Načítání integrací",
    "NO_HOOK_CONFIGURED": "V tomto účtu nejsou nakonfigurovány žádné integrace {integrationId}.",
    "HEADER": "Aplikace",
    "STATUS": {
      "ENABLED": "Povoleno",
      "DISABLED": "Zakázáno"
    },
    "CONFIGURE": "Konfigurace",
    "ADD_BUTTON": "Přidat nový",
    "DELETE": {
      "TITLE": {
        "INBOX": "Potvrdit odstranění",
        "ACCOUNT": "Odpojit"
      },
      "MESSAGE": {
        "INBOX": "Opravdu chcete odstranit?",
        "ACCOUNT": "Opravdu chcete odpojit?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Ano, odstranit",
        "ACCOUNT": "Ano, odpojit"
      },
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "API": {
        "SUCCESS_MESSAGE": "Úspěšně odstraněn",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      }
    },
    "LIST": {
      "FETCHING": "Načítání integračních háčků",
      "INBOX": "Schránka",
      "EDIT": {
        "BUTTON_TEXT": "Upravit"
      },
      "DELETE": {
        "BUTTON_TEXT": "Vymazat"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Vybrat schránku",
          "PLACEHOLDER": "Vybrat schránku"
        },
        "SUBMIT": "Vytvořit",
        "CANCEL": "Zrušit"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrace úspěšně přidána",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      }
    },
    "EDIT": {
      "TITLE": "Upravit {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Vybrat schránku",
          "PLACEHOLDER": "Vybrat schránku"
        },
        "SUBMIT": "Aktualizovat",
        "CANCEL": "Zrušit"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrace úspěšně aktualizována",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Připojit"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Odpojit"
    },
    "SIDEBAR_DESCRIPTION": {
      "DIALOGFLOW": "Dialogflow je platforma pro porozumění přirozenému jazyku, která usnadňuje navrhování a integraci konverzačního uživatelského rozhraní do vaší mobilní aplikace, webové aplikace, zařízení, bota, interaktivního hlasového systému atd. <br /> <br /> Integrace Dialogflow s {installationName} umožňuje nakonfigurovat Dialogflow bota s vašimi schránkami, což umožňuje botovi zpracovat dotazy nejprve a předat je agentovi, když je potřeba. Dialogflow lze použít ke kvalifikaci potenciálních zákazníků, snížení pracovní zátěže agentů poskytováním často kladených otázek atd. <br /> <br /> Chcete-li přidat Dialogflow, je třeba vytvořit účet služby v konzoli projektu Google a sdílet přihlašovací údaje. Další informace naleznete v dokumentaci Dialogflow.",
      "DAKTELA": "Synchronizujte e-maily a webové chaty do svého účtu Daktela.",
      "RETINO": "Retino přináší pořádek do vratek a reklamací.",
      "MAILSHIP": "Mailship je systém pro správu skladu a fulfillment objednávek. Vyhledejte stav objednávky, sledování zásilky a detaily expedice.",
      "CUSTOM_DATA_PROVIDER": "Načtěte data z vlastního serveru a zobrazte je v postranním panelu konverzace. Vrací HTML (zobrazené v iframe) nebo JSON (zobrazený jako seznam klíč/hodnota).",
      "RAYNET": "Připojte svůj účet Raynet CRM a získejte přístup k údajům o zákaznících. Přidejte připojení pomocí uživatelského jména a API tokenu Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Otestovat připojení",
      "SUCCESS": "Připojení úspěšné",
      "ERROR": "Připojení selhalo. Zkontrolujte prosím své přihlašovací údaje."
    }
  }
}
